import {createInstance} from './instance'
import {GetApiUrl} from '../../core/constants/constants'

const generalRequest = createInstance(GetApiUrl())

export { generalRequest }
